import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-[#F5EDE0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-15">
          {/* Para Quién Es */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#B8A068]" data-id="element-16">
            <h3 className="font-playfair text-2xl md:text-3xl font-bold text-[#3D2E1F] mb-8 text-center" data-id="element-17">
              Para quién es esto
            </h3>
            <ul className="space-y-5" role="list" data-id="element-18">
              <li className="flex items-start gap-3" data-id="element-19">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-20" />
                <span className="text-[#3D2E1F]" data-id="element-21">
                  Mujeres de 65 años o más que sienten rigidez al despertar.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-22">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-23" />
                <span className="text-[#3D2E1F]" data-id="element-24">
                  Abuelas que quieren tener la agilidad para jugar con sus
                  nietos.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-25">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-26" />
                <span className="text-[#3D2E1F]" data-id="element-27">
                  Personas que buscan una alternativa natural y suave a los
                  analgésicos.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-28">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-29" />
                <span className="text-[#3D2E1F]" data-id="element-30">
                  Quienes sienten que sus manos y pies "se duermen" o se
                  bloquean por la mañana.
                </span>
              </li>
            </ul>
          </div>

          {/* Para Quién NO Es */}
          <div className="bg-[#FDF8F0] p-8 rounded-2xl shadow-md border-t-4 border-red-300 opacity-90" data-id="element-31">
            <h3 className="font-playfair text-2xl md:text-3xl font-bold text-[#3D2E1F] mb-8 text-center" data-id="element-32">
              Para quién NO es esto
            </h3>
            <ul className="space-y-5" role="list" data-id="element-33">
              <li className="flex items-start gap-3" data-id="element-34">
                <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-35" />
                <span className="text-[#3D2E1F]" data-id="element-36">
                  Personas que buscan una cura milagrosa para cirugías
                  necesarias.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-37">
                <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-38" />
                <span className="text-[#3D2E1F]" data-id="element-39">
                  Jóvenes deportistas que buscan rutinas de alto rendimiento.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-40">
                <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-41" />
                <span className="text-[#3D2E1F]" data-id="element-42">
                  Quienes no están dispuestos a dedicar 5 minutos a su bienestar
                  antes de levantarse.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}